import React from 'react';
import { useSite } from '../../context/SiteContext';

const MaintenancePage = () => {
  const { settings } = useSite();

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'var(--bg-page, #f8f9fa)',
      padding: '2rem',
      fontFamily: 'var(--font-body, system-ui, sans-serif)',
    }}>
      <div style={{
        maxWidth: 520,
        width: '100%',
        textAlign: 'center',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '1.5rem',
      }}>
        {/* Logo */}
        {(settings.site_logo || settings.site_logo_dark) && (
          <img
            src={settings.site_logo || settings.site_logo_dark}
            alt={settings.site_name || 'Logo'}
            style={{ height: 56, objectFit: 'contain', marginBottom: 8 }}
          />
        )}

        {/* Icône maintenance */}
        <div style={{
          width: 80, height: 80,
          borderRadius: '50%',
          background: 'rgba(230,57,70,.08)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          flexShrink: 0,
        }}>
          <svg width="38" height="38" viewBox="0 0 24 24" fill="none"
               stroke="var(--brand-accent, #e63946)" strokeWidth="1.75"
               strokeLinecap="round" strokeLinejoin="round">
            <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"/>
          </svg>
        </div>

        {/* Texte */}
        <div>
          <h1 style={{
            fontSize: 28, fontWeight: 800,
            color: 'var(--text-primary, #111)',
            margin: '0 0 12px',
          }}>
            Site en maintenance
          </h1>
          <p style={{
            fontSize: 16, lineHeight: 1.6,
            color: 'var(--text-secondary, #555)',
            margin: 0,
          }}>
            {settings.maintenance_message ||
              'Nous effectuons une maintenance programmée. Le site sera de nouveau disponible très prochainement. Merci pour votre compréhension.'}
          </p>
        </div>

        {/* Séparateur */}
        <div style={{ width: 48, height: 2, background: 'var(--brand-accent, #e63946)', borderRadius: 2 }} />

        {/* Nom du site */}
        <p style={{ fontSize: 13, color: 'var(--text-muted, #888)', margin: 0 }}>
          {settings.site_name || 'ARTIMARQ'}
          {settings.site_email && (
            <>
              {' · '}
              <a href={`mailto:${settings.site_email}`}
                 style={{ color: 'inherit', textDecoration: 'underline' }}>
                {settings.site_email}
              </a>
            </>
          )}
        </p>

        {/* Lien admin discret */}
        <a
          href="/admin/login"
          style={{
            fontSize: 12, color: 'var(--text-muted, #aaa)',
            textDecoration: 'none', marginTop: 8,
            opacity: 0.5,
            transition: 'opacity .2s',
          }}
          onMouseEnter={e => e.target.style.opacity = 1}
          onMouseLeave={e => e.target.style.opacity = 0.5}
        >
          Accès administrateur
        </a>
      </div>
    </div>
  );
};

export default MaintenancePage;
